import { Location, UIMatch, useLocation, useMatches } from 'react-router'
import { useMemo } from 'react'
import { RouterConfig, RouterConfigEntry } from '../Types/Types'
import { useConfig } from '../../React/Common/Hooks/useConfig'

export const useRouterConfig = (): Nullable<RouterConfigEntry> => {
    const routerConfig: Nullable<RouterConfig> = useConfig('router-config', 'routes')
    const location: Location = useLocation()
    const matches: UIMatch[] = useMatches()

    const pageName: Nullable<string> = useMemo(
        (): Nullable<string> =>
            matches.find((match: UIMatch): boolean => match.pathname.toLowerCase() === location.pathname.toLowerCase())
                ?.id,
        [location, matches]
    )

    return useMemo((): Nullable<RouterConfigEntry> => routerConfig?.[pageName ?? ''], [routerConfig, pageName])
}
